module.exports = {
  ProductSearchBar: require("./product-search-bar"),
  SiteSearchBar: require("./site-search-bar"),
  SitewideSearchBar: require("./sitewide-search-bar"),
  MenuNavigation: require("./menu-navigation"),
  LanguageSelector: require("./language-selector"),
  EmbeddedVideo: require("./embedded-video"),
  AlertBanner: require("./alert-banner"),
  FormHero: require("./form-hero"),
  DownloadList: require("./download-list"),
  SampleBox: require("./sample-box"),
};
